import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'agreementStatusChipIcon',
})
export class AgreementStatusChipIconPipe implements PipeTransform {
  transform(agreementStatus): unknown {
    if (
      agreementStatus === 'accepted' ||
      agreementStatus === 'amendments_accepted' ||
      agreementStatus === 'amendments_declined'
    ) {
      return 'checkmark';
    }
    if (agreementStatus === 'offer_declined' || agreementStatus === 'terminated' || agreementStatus === 'urgent') {
      return 'alert-circle';
    }
    return null;
  }
}
